<template>
  <div class="things-routes full-routes" v-if="list.length > 0">
    <bread-icon class="icon"></bread-icon>
    <router-link class="link-name"
                 :to="setLink(list[0])"
                 v-if="list.length < 1">
      <span v-if="list[0] && list[0].name">
        {{list[0].name}}
      </span>
    </router-link>
    <div v-else-if="list.length"
         @click="show = true"
         @mouseleave="show = false"
         class="link-list">
      <dots-icon class="dots"></dots-icon>
      <transition name="fade">
        <ul class="links-list_inner" v-show="show">
          <router-link tag="li"
                       v-for="link in list"
                       :key="'link' + link.id"
                       :to="setLink(link)"
                       class="link-name_inner">
            <span v-if="link && link.name">
              <trim-item :string="link.name" :width="50"></trim-item>
            </span>
          </router-link>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {breadcrumbsMixin} from "../../../mixins/sidebar/breadcrumbsMixin";

  export default {
    name: 'thingsRoutes',
    mixins: [ breadcrumbsMixin],
    computed: {
      ...mapState({
        activeSection: state => state.things.activeSectionThings,
        thing: state => state.things.device,
        ownedThings: state => state.things.ownedThing,
        allThingsFromGetOwned: state => state.things.allThingsFromGetOwned,
        assignedThings: state => state.things.assignedThings,
      }),
      ...mapGetters({
        tree: 'things/tree'
      }),
      thingsList() {
        return this.ownedThings
      },
      list() {
       // let itemTree;
       let breadscrumbs = [];

       let setPrevDevice = (parentId) => {
         this.allThingsFromGetOwned.forEach((item) => {
           if (item.id === Number(parentId)) {
             breadscrumbs.unshift(item)
             if (item.parent_device_id) {
               setPrevDevice(item.parent_device_id)
             }
           }
         })
       }

       if (this.allThingsFromGetOwned) {
         this.allThingsFromGetOwned.forEach((item) => {
           if (item.id === Number(this.routeId)) {
             // breadscrumbs.push(item)
             if (item.parent_device_id) {
               setPrevDevice(item.parent_device_id)
             }
           }
         })
       }

       // if (this.tree) {
       //   for (let i = 0; i < this.tree.length; i++) {
       //     let item = this.tree[i];
       //     item = JSON.stringify(item);
       //     if (item.includes(this.name) && item.includes(`"id":${this.routeId}`)) {
       //       itemTree = JSON.parse(item);
       //       break;
       //     }
       //   };
       //   if (itemTree) {
       //     let groups = itemTree.groups;
       //     if (groups) {
       //       groups = groups.length;
       //     } else {
       //       groups = 'none'
       //     }
       //     ;
       //     breadscrumbs.push({id: itemTree.id, name: itemTree.name, groups});
       //
       //     function findTheWay(arr, name, routeId) {
       //       findWay(arr);
       //
       //       function findWay(a) {
       //         for (let i = 0; i < a.length; i++) {
       //           let item = a[i];
       //           let itemString = JSON.stringify(item);
       //
       //           if (item.name == name) {
       //             let groups = item.groups;
       //             if (groups) {
       //               groups = groups.length
       //             } else {
       //               groups = 'none'
       //             }
       //             breadscrumbs.push({id: item.id, name: item.name, groups: groups});
       //             break;
       //             return;
       //           }
       //           ;
       //
       //           if (itemString.includes(name) && itemString.includes(`"id":${routeId}`)) {
       //             let groups = item.groups;
       //             if (groups) {
       //               groups = groups.length
       //             } else {
       //               groups = 'none'
       //             }
       //             breadscrumbs.push({id: item.id, name: item.name, groups: groups});
       //             findWay(item.children)
       //           }
       //         }
       //       }
       //     };
       //     findTheWay(itemTree.children, this.name, this.routeId);
       //     breadscrumbs = this.delDouble(breadscrumbs, 'id');
       //     breadscrumbs.pop()
       //   }
       // };
        return breadscrumbs
      }
    },
    methods: {
      setLink(item) {
        if (item) {
          let groups = item.groups;
          if (groups != 'none') {
            return `/things/multithing/${item.id}`
          } else {
            return `/things/thing/${item.id}`
          }
        };
        return '/things'
      }
    }
  }
</script>

<style lang="scss" >
.icon {
  min-width: 6px;
}
</style>

<style lang="scss" scoped>

</style>
